import React from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';
import withGATracker from './analyticsTracker';

const AnalyticsRoute = ({ component: Component, ...rest }) => (
  <Route { ...rest } render={ props => withGATracker(Component, props) } />
);

AnalyticsRoute.propTypes = {
  component: PropTypes.func
};

AnalyticsRoute.defaultProps = {
  component: null
};

export default AnalyticsRoute;



// WEBPACK FOOTER //
// ./src/utils/AnalyticsRoute.js